import http from './httpService';

class AbpUserConfigurationService {
  public async getAll() {
    const href = window.location.href;
    // 回调页不要记 returnUrl，否则登录完成后又跳回 callback 形成循环
    if (
      href.indexOf('dashboard') === -1 &&
      href.indexOf('account/callback') === -1 &&
      href.indexOf('account/slientcallback') === -1
    ) {
      sessionStorage.setItem('returnUrl', href);
    }
    const result = await http.get('/api/AbpUserConfiguration/GetAll');
    return result;
  }
}

export default new AbpUserConfigurationService();
